import React, { useEffect, useMemo } from 'react';
import { Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import HallazgosTable from 'components/admin/Hallazgos/HallazgosTable';
import { useClientes } from 'providers/Clientes/ClientesProvider';
import SectionHint from 'components/ciclo/SectionHint';

function HallazgosPageGlobal() {
  const { call, data, hasCalled } = useClientes();

  useEffect(() => {
    if (!hasCalled) call();
  }, [call, hasCalled]);

  const clientes = useMemo(() => {
    const raw = data?.data || data || [];
    if (!Array.isArray(raw)) return [];
    return raw.filter((c) => c && c.id && c.name).map((c) => ({ id: c.id, name: c.name }));
  }, [data]);

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-5 flex items-start gap-3">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-amber-50 text-amber-600">
          <WarningOutlined className="text-xl" />
        </div>
        <div>
          <Typography.Title level={3} className="!mb-1 !text-slate-800">
            Hallazgos
          </Typography.Title>
          <Typography.Text type="secondary" className="text-sm">
            Incidencias y sugerencias detectadas durante mantenciones de todos los clientes.
          </Typography.Text>
        </div>
      </div>

      <div className="mb-4">
        <SectionHint
          id="hallazgos-global"
          message="Acá empieza el ciclo de trabajo"
          description="Los hallazgos se detectan en las mantenciones y emergencias. Seleccioná los que están en etapa Detectado y presioná Presupuestar para cotizarlos."
        />
      </div>

      <HallazgosTable clientes={clientes} />
    </div>
  );
}

export default HallazgosPageGlobal;
